"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("../../constant");

var _useFetch7 = _interopRequireDefault(require("../../Store/useFetch"));

var _jwtTokenService = _interopRequireDefault(require("@airasia/phoenix-components/components/JwtTokenProvider/jwtTokenService"));

var _calendarInstance = _interopRequireDefault(require("../calendar-instance/calendarInstance"));

var _calendar = require("../calendar.utilities");

var _constant2 = require("../constant");

var _calendarwidget = _interopRequireDefault(require("./calendarwidget.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Widget = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__Widget",
  componentId: "sc-u2xaxz-0"
})(["background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
});

var Calendar = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__Calendar",
  componentId: "sc-u2xaxz-1"
})([""]);

var CalendarInstanceContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__CalendarInstanceContainer",
  componentId: "sc-u2xaxz-2"
})(["display:flex;flex-direction:row;"]);

var CalendarInstance = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__CalendarInstance",
  componentId: "sc-u2xaxz-3"
})(["display:flex;flex:1;padding:0 ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.XXSmall;
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__Divider",
  componentId: "sc-u2xaxz-4"
})(["width:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.semiLarge;
});

var CalendarMobile = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__CalendarMobile",
  componentId: "sc-u2xaxz-5"
})(["display:flex;flex-direction:column;overflow:hidden;height:0;"]);

var CalendarItemContainer = _styledComponents.default.div.withConfig({
  displayName: "calendarwidget__CalendarItemContainer",
  componentId: "sc-u2xaxz-6"
})(function (_ref4) {
  var theme = _ref4.theme;
  return "\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    /* width */\n    ::-webkit-scrollbar {\n          width: 4px;\n      }\n\n      /* Track */\n      ::-webkit-scrollbar-track {\n          background: transparent;\n      }\n\n      /* Handle */\n      ::-webkit-scrollbar-thumb {\n          background: ".concat(theme.colors.greyMedium, ";\n          border-radius: ").concat(theme.borderRadius.normal, ";\n      }\n  ");
});

var AaCalendarWidget = function AaCalendarWidget(props) {
  var controls = props.controls,
      dates = props.dates,
      dataFormatDate = props.dataFormatDate,
      dataFormatCurrency = props.dataFormatCurrency,
      theme = props.theme,
      lfcConfig = props.lfcConfig,
      enableLFC = props.enableLFC,
      environment = props.environment,
      lfcDepartEndpoint = props.lfcDepartEndpoint,
      lfcReturnEndpoint = props.lfcReturnEndpoint,
      prefillLfcOneWayPrice = props.prefillLfcOneWayPrice,
      prefillLfcReturnPrice = props.prefillLfcReturnPrice,
      snapLfcPrices = props.snapLfcPrices,
      customDateLabels = props.customDateLabels,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      isSnapCalendar = props.isSnapCalendar,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      flightDepart = props.flightDepart,
      flightReturn = props.flightReturn,
      minNights = props.minNights,
      enableAvailableDateCalendarFlag = props.enableAvailableDateCalendarFlag;
  var member = lfcConfig.member,
      role = lfcConfig.role,
      baseCurrency = lfcConfig.baseCurrency,
      currency = lfcConfig.currency,
      origin = lfcConfig.origin,
      destination = lfcConfig.destination,
      _lfcConfig$monthsToDi = lfcConfig.monthsToDisplay,
      monthsToDisplay = _lfcConfig$monthsToDi === void 0 ? 3 : _lfcConfig$monthsToDi;
  var selectionType = controls.selectionType,
      viewType = controls.viewType;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var myscroll = (0, _react.useRef)(null);
  var startDate = new Date();
  var maxDays = controls.maxDays;

  var maxDate = _calendar.AaCalendarUtilities.addDaysToDate(startDate, maxDays);

  var monthsDifference = _calendar.AaCalendarUtilities.monthsDifference(startDate, maxDate);

  var hotelMonthsDifference = isPartialHotelCalendar ? _calendar.AaCalendarUtilities.monthsDifference(flightDepart, flightReturn) : 0;

  var diff = _calendar.AaCalendarUtilities.monthsDifference(startDate, new Date(dates.departDate));

  var _useFetch = (0, _useFetch7.default)(null, 'lfcOneWayResponse'),
      _useFetch2 = (0, _slicedToArray2.default)(_useFetch, 2),
      lfcOneWayResponse = _useFetch2[0],
      fetchLfcOneWayResponse = _useFetch2[1];

  var _useFetch3 = (0, _useFetch7.default)(null, 'lfcReturnResponse'),
      _useFetch4 = (0, _slicedToArray2.default)(_useFetch3, 2),
      lfcReturnResponse = _useFetch4[0],
      fetchLfcReturnResponse = _useFetch4[1];

  var _useFetch5 = (0, _useFetch7.default)(null, 'multiCurrency'),
      _useFetch6 = (0, _slicedToArray2.default)(_useFetch5, 1),
      multiCurrency = _useFetch6[0];

  var _useState = (0, _react.useState)(prefillLfcOneWayPrice),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      lfcOneWayPrice = _useState2[0],
      setLfcOneWayPrice = _useState2[1];

  var _useState3 = (0, _react.useState)(prefillLfcReturnPrice),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      lfcReturnPrice = _useState4[0],
      setLfcReturnPrice = _useState4[1];

  var _useState5 = (0, _react.useState)(1),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      exchangeRate = _useState6[0],
      setExchangeRate = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      departPrice = _useState8[0],
      setDepartPrice = _useState8[1];
  /**
   * States that determine the months to be displayed in left and right calendars
   */


  var _useState9 = (0, _react.useState)(new Date(dates.departDate)),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      departCalendarDate = _useState10[0],
      setDepartCalendarDate = _useState10[1];

  var _useState11 = (0, _react.useState)(_calendar.AaCalendarUtilities.addMonthToDate(departCalendarDate, 1)),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      returnCalendarDate = _useState12[0],
      setReturnCalendarDate = _useState12[1];
  /**
   * States that determine if Previous and Next Calendar button will be enabled/disabled.
   * Enable Previous button if the previous month is not today's month
   */


  var _useState13 = (0, _react.useState)(diff > 0),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      enablePrevButton = _useState14[0],
      setEnablePrevButton = _useState14[1];

  var _useState15 = (0, _react.useState)(true),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      enableNextButton = _useState16[0],
      setEnableNextButton = _useState16[1];

  var ssrServiceRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!multiCurrency) {
      return;
    }

    if (multiCurrency.isFetching || multiCurrency.isError) {
      return;
    }

    if (!currency) {
      return;
    }

    var rate = 1;

    if (currency !== baseCurrency) {
      rate = multiCurrency.data[currency.toUpperCase()];
    }

    setExchangeRate(Number(rate));
  }, [baseCurrency, currency, multiCurrency]);
  (0, _react.useEffect)(function () {
    if (viewType === _constant2.CALENDAR_VIEW_TYPE.MOBILE && typeof document !== 'undefined') {
      var totalScroll = 0;
      var latestMonth = startDate;

      for (var i = latestMonth.getMonth(); i <= diff; i++) {
        var selector = isPartialHotelCalendar ? "#partialHotelCalendar-instance-".concat(latestMonth.getMonth(), "-").concat(latestMonth.getFullYear()) : "#calendar-instance-".concat(latestMonth.getMonth(), "-").concat(latestMonth.getFullYear());
        var element = document.querySelector(selector);

        if (element) {
          totalScroll += element.offsetHeight;
        }

        latestMonth = _calendar.AaCalendarUtilities.addMonthToDate(latestMonth, 1);
      }

      var id = isPartialHotelCalendar ? '#partialHotelMobileScroll-container' : '#mobileScroll-container';
      var mobileScrollContainer = document.querySelector(id);

      if (mobileScrollContainer) {
        mobileScrollContainer.scrollTop = totalScroll;
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [viewType]);

  var getNewJwtToken = function getNewJwtToken() {
    return new Promise(function (resolve, reject) {
      ssrServiceRef.current = new _jwtTokenService.default(); // if (props.controls.channelHash) ssrServiceRef.current.channelHash = props.controls.channelHash;

      ssrServiceRef.current.getJsonTokenForCalendarLfcCall(environment).then(function (res) {
        if (res && res.includes('Bearer ')) {
          localStorage.setItem('calendarToken', res);
          resolve(res.replace('Bearer ', ''));
        }
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  var makeLfcCall = function makeLfcCall(token) {
    var headers = {
      'X-Custom-Flag': '1',
      Authorization: "Bearer ".concat(token)
    };
    var endpoint;
    var formattedUrl;

    var today = _calendar.AaCalendarUtilities.formatDates(new Date(), 'yyyy-MM-dd');

    if (!prefillLfcOneWayPrice) {
      if (lfcDepartEndpoint) {
        endpoint = lfcDepartEndpoint;
      } else {
        endpoint = _constant2.DEFAULT_LFC_ENDPOINT[environment];
      }

      formattedUrl = _calendar.AaCalendarUtilities.formatString(endpoint, [member, role, baseCurrency.toUpperCase(), origin.toUpperCase(), destination.toUpperCase(), today, _constant2.TOGGLE_DATE_SELECTION.DEPART, monthsToDisplay]);
      fetchLfcOneWayResponse({
        url: formattedUrl,
        method: _constant.HTTPS_METHOD.GET,
        headers: headers
      });
    }

    if (selectionType === _constant2.TOGGLE_DATE_SELECTION.DEPART) {
      return;
    }

    if (!prefillLfcReturnPrice) {
      if (lfcReturnEndpoint) {
        endpoint = lfcReturnEndpoint;
      } else {
        endpoint = _constant2.DEFAULT_LFC_ENDPOINT[environment];
      }

      formattedUrl = _calendar.AaCalendarUtilities.formatString(endpoint, [member, role, baseCurrency.toUpperCase(), destination.toUpperCase(), origin.toUpperCase(), today, _constant2.TOGGLE_DATE_SELECTION.RETURN, monthsToDisplay]);
      fetchLfcReturnResponse({
        url: formattedUrl,
        method: _constant.HTTPS_METHOD.GET,
        headers: headers
      });
    }
  };

  (0, _react.useEffect)(function () {
    if (!enableLFC || customDateLabels) {
      return;
    }

    if (!origin || !destination) {
      return;
    }

    if (prefillLfcOneWayPrice && prefillLfcReturnPrice) {
      return;
    }

    getNewJwtToken().then(function (res) {
      if (!res) {
        return;
      }

      makeLfcCall(res);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableLFC]);
  /**
   * Resets the calendar when user press `Reset` button
   */

  (0, _react.useEffect)(function () {
    if (controls.resetData) {
      setDepartCalendarDate(new Date());
      setReturnCalendarDate(_calendar.AaCalendarUtilities.addMonthToDate(new Date(), 1));
      setEnablePrevButton(false);
      setEnableNextButton(true);
    }
  }, [controls.resetData]);
  var dateToManipulate = startDate;
  var hotelDateToManipulate = isPartialHotelCalendar && flightDepart;
  var hotelMonthsYearArray = isPartialHotelCalendar ? [{
    month: hotelDateToManipulate.getMonth(),
    year: hotelDateToManipulate.getFullYear()
  }] : null;
  /**
   * Array of `{ month: string, year: string }` that will be used as
   * calendar instance title.
   *
   * Example: January 2020
   */

  var monthsYearArray = [{
    month: dateToManipulate.getMonth(),
    year: dateToManipulate.getFullYear()
  }];
  /**
   *
   * @param {Date} date - selected depart date object
   * @param {number} price - depart date price
   *
   * Sets depart date and price.
   * Toggles that the next date selection will be for return date
   */
  // eslint-disable-next-line no-unused-vars

  var getDepartureDate = function getDepartureDate(date, price) {
    if (controls.selectionType && controls.selectionType === _constant2.CALENDAR_SELECTION_TYPE.TWO) {
      controls.toggleDateSelection(_constant2.TOGGLE_DATE_SELECTION.RETURN);
    }

    controls.onDepartChange(date);
    setDepartPrice(price);
  };
  /**
   *
   * @param {Date} date - selected return date object
   *
   * Sets return date.
   * Toggles that the next date selection will be for depart date again
   */


  var getReturnDate = function getReturnDate(date) {
    if (!date) {
      controls.toggleDateSelection(_constant2.TOGGLE_DATE_SELECTION.RETURN);
    } else {
      controls.toggleDateSelection(_constant2.TOGGLE_DATE_SELECTION.DEPART);
    }

    controls.onReturnChange(date);
  };
  /**
   * Handles the actions when `Previous` button of calendar was clicked
   */


  var onBackCalendar = function onBackCalendar() {
    if (!enablePrevButton) {
      return;
    }

    setDepartCalendarDate(_calendar.AaCalendarUtilities.subtractMonthToDate(departCalendarDate, 1));
    setReturnCalendarDate(_calendar.AaCalendarUtilities.subtractMonthToDate(returnCalendarDate, 1));
    if (!enableNextButton) setEnableNextButton(true);

    if (_calendar.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate(_calendar.AaCalendarUtilities.subtractMonthToDate(departCalendarDate, 1), startDate)) {
      setEnablePrevButton(false);
    } else {
      setEnablePrevButton(true);
    }
  };
  /**
   * Handles the actions when `Next` button of calendar was clicked
   */


  var onNextCalendar = function onNextCalendar() {
    if (!enableNextButton) {
      return;
    }

    var nextCalendarDate = _calendar.AaCalendarUtilities.addMonthToDate(returnCalendarDate, 1);

    setDepartCalendarDate(_calendar.AaCalendarUtilities.addMonthToDate(departCalendarDate, 1));
    setReturnCalendarDate(nextCalendarDate);
    if (!enablePrevButton) setEnablePrevButton(true);

    if (_calendar.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(nextCalendarDate, maxDate) || nextCalendarDate.getMonth() === maxDate.getMonth() && nextCalendarDate.getFullYear() === maxDate.getFullYear()) {
      setEnableNextButton(false);
    } else {
      setEnableNextButton(true);
    }
  };
  /**
   * Configuration object for depart calendar instance
   */


  var departCalendarInstanceConfig = {
    controls: {
      onDepartSelected: getDepartureDate,
      onReturnSelected: getReturnDate,
      onPrevButtonClicked: onBackCalendar,
      // eslint-disable-next-line eqeqeq
      showDaysDisplay: controls.viewType != '2'
    }
  };
  /**
   * Configuration object for return calendar instance
   */

  var returnCalendarInstanceConfig = {
    controls: {
      onDepartSelected: getDepartureDate,
      onReturnSelected: getReturnDate,
      onNextButtonClicked: onNextCalendar,
      showDaysDisplay: true
    }
  };
  var data = {
    departDate: {
      year: dates.departDate ? dates.departDate.getFullYear() : null,
      month: dates.departDate ? dates.departDate.getMonth() : null,
      date: dates.departDate ? dates.departDate.getDate() : null
    },
    returnDate: {
      year: dates.returnDate ? dates.returnDate.getFullYear() : null,
      month: dates.returnDate ? dates.returnDate.getMonth() : null,
      date: dates.returnDate ? dates.returnDate.getDate() : null
    }
  };
  (0, _react.useEffect)(function () {
    if (!prefillLfcOneWayPrice) {
      return;
    }

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(data.departDate.year, data.departDate.month, data.departDate.date));

    setDepartPrice(prefillLfcOneWayPrice[formattedDate]);
  }, [prefillLfcOneWayPrice, data.departDate]);
  (0, _react.useEffect)(function () {
    if (!lfcConfig) {
      return;
    }

    if (!origin || !destination) {
      return;
    }

    if (!lfcOneWayResponse) {
      return;
    }

    if (lfcOneWayResponse.isFetching || lfcOneWayResponse.isError) {
      return;
    }

    if (typeof baseCurrency !== 'string') {
      return;
    }

    var dataHolder = lfcOneWayResponse.data;
    var priceList = dataHolder["".concat(origin.toUpperCase()).concat(destination.toUpperCase(), "|").concat(baseCurrency.toUpperCase())] || null;

    if (!priceList) {
      return;
    }

    setLfcOneWayPrice(priceList);

    var formattedDate = _calendar.AaCalendarUtilities.datePayloadFormat(new Date(data.departDate.year, data.departDate.month, data.departDate.date));

    setDepartPrice(priceList[formattedDate]);
  }, [lfcOneWayResponse, lfcConfig, data.departDate, origin, destination, baseCurrency]);
  (0, _react.useEffect)(function () {
    if (!lfcConfig) {
      return;
    }

    if (!origin || !destination) {
      return;
    }

    if (!lfcReturnResponse) {
      return;
    }

    if (lfcReturnResponse.isFetching || lfcReturnResponse.isError) {
      return;
    }

    if (typeof baseCurrency !== 'string') {
      return;
    }

    var dataHolder = lfcReturnResponse.data;
    var priceList = dataHolder["".concat(destination.toUpperCase()).concat(origin.toUpperCase(), "|").concat(baseCurrency.toUpperCase())] || null;

    if (!priceList) {
      return;
    }

    setLfcReturnPrice(priceList);
  }, [lfcReturnResponse, lfcConfig, destination, origin, baseCurrency]);

  var showItem = function showItem() {
    var items = [];
    var monthsYearArrayToUse = isPartialHotelCalendar ? hotelMonthsYearArray : monthsYearArray;

    for (var i = 0; i < monthsYearArrayToUse.length; i += 1) {
      var control = _objectSpread(_objectSpread({}, departCalendarInstanceConfig.controls), {}, {
        calendarIndex: 0,
        showPrevButton: false,
        showNextButton: false,
        year: monthsYearArrayToUse[i].year.toString(),
        month: monthsYearArrayToUse[i].month.toString(),
        selectForDepart: controls.selectForDepart,
        selectForReturn: controls.selectForReturn,
        maxDate: maxDate,
        maxDays: maxDays,
        selectionType: controls.selectionType,
        dataFormatDate: dataFormatDate,
        maxDisplayedDate: returnCalendarDate,
        currency: isSnapCalendar ? currency : null,
        departPrice: isSnapCalendar ? departPrice : null
      });

      items.push( /*#__PURE__*/_react.default.createElement(_calendarInstance.default, {
        key: "Instance".concat(i),
        controls: control,
        data: data,
        theme: theme,
        isOnlyApplyForHotel: isOnlyApplyForHotel,
        isSnapCalendar: isSnapCalendar,
        snapLfcPrices: snapLfcPrices,
        isPartialHotelCalendar: isPartialHotelCalendar,
        flightDepart: flightDepart,
        flightReturn: flightReturn,
        minNights: minNights,
        lfcPrices: {
          oneway: lfcOneWayPrice,
          return: lfcReturnPrice
        },
        enableAvailableDateCalendarFlag: enableAvailableDateCalendarFlag
      }));
    }

    return items;
  };
  /**
   * Add all months and years in `monthsYearArray` array
   */


  for (var i = 1; i <= monthsDifference; i += 1) {
    dateToManipulate = _calendar.AaCalendarUtilities.addMonthToDate(dateToManipulate, 1);
    var monthYear = {
      month: dateToManipulate.getMonth(),
      year: dateToManipulate.getFullYear()
    };
    monthsYearArray.push(monthYear);
  }

  if (isPartialHotelCalendar) {
    for (var _i = 1; _i <= hotelMonthsDifference; _i += 1) {
      hotelDateToManipulate = _calendar.AaCalendarUtilities.addMonthToDate(hotelDateToManipulate, 1);
      var hotelMonthYear = {
        month: hotelDateToManipulate.getMonth(),
        year: hotelDateToManipulate.getFullYear()
      };
      hotelMonthsYearArray.push(hotelMonthYear);
    }
  }

  var setFixHeight = function setFixHeight() {
    var id = isPartialHotelCalendar ? 'partialHotelCalendarBody' : 'calenderbody';

    if (typeof document !== 'undefined' && myscroll.current) {
      myscroll.current.style.height = 0;
      var element = document.getElementById(id);

      if (element) {
        var bodyHeight = element.offsetHeight;
        myscroll.current.style.height = "".concat(bodyHeight - 32, "px");
      }
    }
  };

  (0, _react.useEffect)(function () {
    if (myscroll) {
      setFixHeight();

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', setFixHeight);
      }
    }

    return function () {
      window.removeEventListener('resize', setFixHeight);
    };
  }, [myscroll]);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Widget, null, !controls.viewType || controls.viewType === _constant2.CALENDAR_VIEW_TYPE.DESKTOP ? /*#__PURE__*/_react.default.createElement(Calendar, null, /*#__PURE__*/_react.default.createElement(CalendarInstanceContainer, null, /*#__PURE__*/_react.default.createElement(CalendarInstance, null, /*#__PURE__*/_react.default.createElement(_calendarInstance.default, {
      controls: _objectSpread(_objectSpread({}, departCalendarInstanceConfig.controls), {}, {
        calendarIndex: 0,
        showPrevButton: isPartialHotelCalendar ? flightDepart.getMonth() < departCalendarDate.getMonth() : true,
        year: departCalendarDate.getFullYear(),
        month: departCalendarDate.getMonth(),
        enablePrevButton: enablePrevButton,
        selectForDepart: controls.selectForDepart,
        selectForReturn: controls.selectForReturn,
        maxDate: maxDate,
        maxDays: maxDays,
        selectionType: controls.selectionType,
        resetData: controls.resetData,
        dataFormatDate: dataFormatDate,
        dataFormatCurrency: dataFormatCurrency,
        maxDisplayedDate: returnCalendarDate,
        departPrice: departPrice,
        currency: currency,
        customDateLabels: customDateLabels
      }),
      data: data,
      lfcPrices: {
        oneway: lfcOneWayPrice,
        return: lfcReturnPrice
      },
      snapLfcPrices: snapLfcPrices,
      isSnapCalendar: isSnapCalendar,
      isPartialHotelCalendar: isPartialHotelCalendar,
      flightDepart: flightDepart,
      flightReturn: flightReturn,
      minNights: minNights,
      theme: theme,
      exchangeRate: exchangeRate,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      enableAvailableDateCalendarFlag: enableAvailableDateCalendarFlag
    })), /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(CalendarInstance, null, /*#__PURE__*/_react.default.createElement(_calendarInstance.default, {
      controls: _objectSpread(_objectSpread({}, returnCalendarInstanceConfig.controls), {}, {
        calendarIndex: 1,
        showNextButton: isPartialHotelCalendar ? flightReturn.getMonth() > returnCalendarDate.getMonth() : true,
        year: returnCalendarDate.getFullYear(),
        month: returnCalendarDate.getMonth(),
        enableNextButton: enableNextButton,
        selectForDepart: controls.selectForDepart,
        selectForReturn: controls.selectForReturn,
        maxDate: maxDate,
        selectionType: controls.selectionType,
        resetData: controls.resetData,
        dataFormatDate: dataFormatDate,
        dataFormatCurrency: dataFormatCurrency,
        maxDisplayedDate: returnCalendarDate,
        departPrice: departPrice,
        currency: currency,
        customDateLabels: customDateLabels
      }),
      data: data,
      lfcPrices: {
        oneway: lfcOneWayPrice,
        return: lfcReturnPrice
      },
      snapLfcPrices: snapLfcPrices,
      isSnapCalendar: isSnapCalendar,
      isPartialHotelCalendar: isPartialHotelCalendar,
      flightDepart: flightDepart,
      flightReturn: flightReturn,
      minNights: minNights,
      theme: theme,
      exchangeRate: exchangeRate,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      enableAvailableDateCalendarFlag: enableAvailableDateCalendarFlag
    })))) : null, controls.viewType === _constant2.CALENDAR_VIEW_TYPE.MOBILE ? /*#__PURE__*/_react.default.createElement(CalendarMobile, {
      className: "Mobilescroll",
      ref: myscroll
    }, /*#__PURE__*/_react.default.createElement(CalendarItemContainer, {
      id: isPartialHotelCalendar && 'partialHotelMobileScroll-container' || 'mobileScroll-container'
    }, showItem())) : null);
  };

  getMain.propTypes = _calendarwidget.default.PropTypes;
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

AaCalendarWidget.propTypes = _calendarwidget.default.PropTypes;
var _default = AaCalendarWidget;
exports.default = _default;